import _ from 'underscore';
import Backbone from '@trello/backbone';

type BackboneEvents = typeof Backbone.Events;
export interface WebSocketEvents extends BackboneEvents {
  trigger(
    name:
      | 'data'
      | 'connect'
      | 'connecting'
      | 'connect_failed'
      | 'reconnect'
      | 'reconnecting'
      | 'reconnect_now'
      | 'reconnect_failed'
      | 'waiting_for_focus'
      | 'waiting_for_user'
      | 'disconnect'
      | 'close'
      | 'error'
      | 'message'
      | 'open',
    data?: string,
  ): this;
  listenTo: (
    webSocketEvents: WebSocketEvents,
    event: 'close' | 'error' | 'message' | 'open',
    callback: (event?: Event) => void,
  ) => void;
}

export const webSocketEvents: WebSocketEvents = _.extend({}, Backbone.Events);
